// Copyright Contributors to the Packit project.
// SPDX-License-Identifier: MIT

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/usage")({
  staticData: {
    title: "Usage",
  },
});
